<template>
    <div class="info-icon-container" v-tooltip.top="{
        content: htmlText,
        classes: 'tooltip',
        trigger: isMobile ? 'click' : 'hover',
    }">
        <img :src="theme.tooltipSrcIcon" alt="information icon" width="16px" />
    </div>
</template>

<script>
import getTheme from "@/utils/theme";

export default {
    name: "IconTooltip",
    props: ["htmlText"],
    data() {
        return {
            theme: getTheme(),
            windowWidth: null,
        };
    },
    computed: {
        isMobile() {
            if (this.windowWidth < 768) {
                return true;
            }
            return false;
        },
    },
    created() {
        this.windowWidth = window.innerWidth;
    },
    mounted() {
        window.addEventListener("resize", () => {
            this.windowWidth = window.innerWidth;
        });
    },
};
</script>
